
// =======================
// IMPORT
// =======================

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import "./extensions/turbolinks"
import * as ActiveStorage from "@rails/activestorage"

import jquery from "jquery"
window.$ = window.jQuery = jquery

Rails.start()
Turbolinks.start()
ActiveStorage.start()

import '@fortawesome/fontawesome-free/js/all.min'
import 'bootstrap/dist/js/bootstrap.bundle.min'

import select2 from 'select2'
select2()

import 'slick-carousel'

import './packs/base_theme'
import './packs/direction_map'


// =======================
// VIDEO RESIZE (FIXED)
// =======================

function resizeVideoMasthead() {
  let theWidth, theHeight;

  if ($('body').data('device')?.match(/(iphone|ipad)/)) {
    theWidth = window.screen.width;
    theHeight = window.screen.height;
  } else {
    theWidth = window.innerWidth;
    theHeight = window.innerHeight;
  }

  let newWidth, newHeight;

  if ((theWidth / theHeight) >= (16 / 9)) {
    newWidth = theWidth;
    newHeight = theWidth / 9 * 16;
  } else {
    newWidth = theHeight / 9 * 16;
    newHeight = theHeight;
  }

  $('.video-venue-masthead--video__container').css({
    width: newWidth,
    height: newHeight
  });
}


// =======================
// GLOBAL EVENTS (SAFE)
// =======================

// Beer description toggle
$(document).on('click', '.beer_desc_cta', function () {
  const el = $(this).siblings('.beer_desc_caption');
  if (!el.length) return;

  el.stop(true, true).toggle(300);
});

// Beer logo zoom
$(document).on('click', '.beerlogo', function () {
  const imgSrc = $('img.beerlogo-sticker', this).attr('src');
  if (!imgSrc) return;

  $('.beerlogo_zoom img').attr('src', imgSrc);
  $('.beerlogo_zoom').show(100);
});

$(document).on('click', '.beerlogo_zoom__close', function () {
  $('.beerlogo_zoom').hide(100);
});

// Global UI close
$(document).on('click', '.nav-link', function () {
  $('.beerlogo_zoom').hide(100);
  $('.menu-alert').hide(100);
});

$(document).on('click', '.menu-alert__close-cta', function () {
  $('.menu-alert').hide(100);
});

// Scroll trigger
$(document).on('click', '.js-scroll-trigger', function () {
  $('.navbar-collapse').collapse('hide');
});


// =======================
// POINTS CARD
// =======================

$(document).on('click', '.points_card_nav_menu', function (e) {
  e.preventDefault();
  e.stopPropagation();

  $('.menu-alert.points_card_popup_form')
    .stop(true, true)
    .fadeIn(100);
});


// =======================
// SEARCH
// =======================

$(document).on('click', '.btn-beer-search-barcode', searchBarcodeTrigger);

$(document).on('keypress', '.search-input-barcode', function (e) {
  if (e.which === 13) {
    searchBarcodeTrigger();
    document.activeElement.blur();
  }
});

$(document).on('click', '.btn-beer-search-desk', function () {
  searchTrigger('desk');
});

$(document).on('keypress', '.search-input-desk', function (e) {
  if (e.which === 13) searchTrigger('desk');
});

$(document).on('click', '.btn-beer-search-mobile', function () {
  searchTrigger('mobile');
});

$(document).on('keypress', '.search-input-mobile', function (e) {
  if (e.which === 13) {
    searchTrigger('mobile');
    document.activeElement.blur();
  }
});


// =======================
// WINDOW EVENTS
// =======================

$(window)
  .off('resize.video')
  .on('resize.video', function () {
    resizeVideoMasthead();
  });


// =======================
// TURBOLINKS LOAD
// =======================

document.addEventListener("turbolinks:load", function () {

  // 🔥 FIX IMPORTANTE: primo resize sempre corretto
  resizeVideoMasthead();

  // QR auto trigger
  setTimeout(function () {
    if (window.location.search === "?qrBeershop=1") {
      $('a.nav-link:contains("Beershop")').trigger('click');
    }
  }, 200);

  // tabs
  $('#menu-tab a').off('click').on('click', function (e) {
    e.preventDefault();
    $(this).tab('show');
  });

  // scrollspy
  $('body').scrollspy({
    target: '#mainNav',
    offset: 100
  });

  // navbar collapse
  if ($("#mainNav").length > 0) {

    const navbarCollapse = function () {
      if ($("#mainNav").offset().top > 100) {
        $("#mainNav").addClass("navbar-shrink");
      } else {
        $("#mainNav").removeClass("navbar-shrink");
      }
    };

    navbarCollapse();

    $(window)
      .off('scroll.navbar')
      .on('scroll.navbar', navbarCollapse);

    if (window.innerWidth <= 992) {
      $('body').data('device', 'ipad');
    }
    if (window.innerWidth <= 768) {
      $('body').data('device', 'iphone');
    }
  }

  // menu behavior
  $('.nav-item.nav-link a').addClass('js-scroll-trigger');

  $('.menu-item .js-scroll-trigger')
    .off('click')
    .on('click', function () {
      $('.navbar-collapse').removeClass('show');
    });
});


// =======================
// FUNCTIONS
// =======================

function searchBarcodeTrigger() {
  $('.search-barcode-result').empty();

  var venueId = $('[data-venue]').data('venue');
  var searchString = $(".search-input-barcode").val();

  Rails.ajax({
    url: "/pc_barcode_search?vid=" + venueId + "&q=" + searchString,
    type: "get",
    success: function (data) {
      let points = data['points'] == null
        ? 'Tessera Errata!'
        : ("Punti: " + data['points']);

      $('.search-barcode-result').append(points);
    }
  });
}

function searchTrigger(device) {
  var venueId = $('[data-venue]').data('venue');
  var searchString = $(".search-input-" + device).val();

  Rails.ajax({
    url: "/beer_search_routine?vid=" + venueId + "&q=" + searchString,
    type: "get",
    success: function (data) {
      $('.row-beershop').remove();
      $('.hr-beershop').remove();
      updateBeershopRow(data, device);
    }
  });
}

function updateBeershopRow(data, device) {

  $.each(data['collection'], function (_index, value) {

    var siteLang = document.cookie.match(/tgm_lang=([^;]+)/)?.[1] || 'it';

    var new_product = '';
    var gfreeElem = '';
    var newline = '';
    var descriptionLine = '';
    var square_image = 'border-radius:99rem;';

    if (value['new'] === true) {
      new_product = "<span class='tab-ribbon'>NEW</span>";
    }

    if (value['gluten_free'] === true) {
      newline = '<br />';
      gfreeElem = "<span class='gfree'>G•FREE</span>";
    }

    if (value['square_image'] === true) {
      square_image = 'border-radius:5px;';
    }

    if (value["description_" + siteLang]?.length > 10) {
      descriptionLine =
        "<label class='small beer_desc_cta'>&#8675 " +
        value['description_cta'] +
        " &#8675</label>" +
        "<div class='small beer_desc_caption' style='opacity:0.8; display:none'>" +
        value["description_" + siteLang] +
        "</div>";
    }

    let image_html_segment = '';

    if (value['image']?.length > 0) {
      image_html_segment =
        "<div class='col-xl-1 col-lg-1 col-sm-2 col-4'>" +
        "<div class='beerlogo'>" +
        new_product +
        "<img src='" + value['image'] + "' class='beerlogo-sticker' style='" + square_image + "'>" +
        "</div></div>";
    }

    let html =
      "<div class='row mb-3 row-beershop'>" +
      image_html_segment +
      "<div class='col-xl-7 col-lg-6 col-sm-6 col-8 px-2'>" +
      "<p class='menu-row-title'>" + value['fullname'] + newline + gfreeElem + "</p>" +
      "<div class='small mb-1' style='display:block;'>" + value['caption_one'] + "</div>" +
      "<div class='small' style='display:block;'>" + value['caption_two'] + "</div>" +
      descriptionLine +
      "</div>" +
      "<div class='col-xl-4 col-lg-5 col-sm-4 text-end'>";

    if (value['finished']) {
      html += "<small class='flag-finished-" + siteLang + "'></small>";
    }

    html += "<strong>" + value['price'] + "</strong></div></div>" +
      "<hr class='hr-beershop' style='border-color:rgba(255,255,255,0.3); border-style:dashed'>";

    $("#beershop-" + device).append(html);
  });
}